/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponseInfo
 */
export interface ResponseInfo {
    /**
     * 
     * @type {string}
     * @memberof ResponseInfo
     */
    httpVerb?: string;
    /**
     * Unique request/response id (might be added in the future to the http header)
     * @type {string}
     * @memberof ResponseInfo
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseInfo
     */
    requestData?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseInfo
     */
    responseData?: string;
    /**
     * 
     * @type {number}
     * @memberof ResponseInfo
     */
    statusCode?: number;
    /**
     * 
     * @type {string}
     * @memberof ResponseInfo
     */
    uri?: string;
}

/**
 * Check if a given object implements the ResponseInfo interface.
 */
export function instanceOfResponseInfo(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResponseInfoFromJSON(json: any): ResponseInfo {
    return ResponseInfoFromJSONTyped(json, false);
}

export function ResponseInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'httpVerb': !exists(json, 'httpVerb') ? undefined : json['httpVerb'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'requestData': !exists(json, 'requestData') ? undefined : json['requestData'],
        'responseData': !exists(json, 'responseData') ? undefined : json['responseData'],
        'statusCode': !exists(json, 'statusCode') ? undefined : json['statusCode'],
        'uri': !exists(json, 'uri') ? undefined : json['uri'],
    };
}

export function ResponseInfoToJSON(value?: ResponseInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'httpVerb': value.httpVerb,
        'id': value.id,
        'requestData': value.requestData,
        'responseData': value.responseData,
        'statusCode': value.statusCode,
        'uri': value.uri,
    };
}

